import { MeetingHeader } from '@/components/molecules/Header/MeetingHeader'
import { CustomMeetingControls } from '@components/organisms/CustomMeetingControls/CustomMeetingControls'
import { MeetingVideoGrid } from '@components/organisms/MeetingVideoGrid/MeetingVideoGrid'
import { AppTemplate } from '@components/templates/AppTemplate/AppTemplate'

/**
 * Demo version of Meeting page
 * Works without backend - displays UI for design/development work
 * Access via /meeting/demo
 *
 * Note: This is a simplified version that doesn't require an active Chime session.
 * It displays the meeting UI for frontend development purposes.
 */
export function MeetingDemoPage() {
  return (
    <AppTemplate header={<MeetingHeader showMeetingInfo />} className="bg-primary">
      <div className="flex w-full flex-1 flex-col gap-8">
        <MeetingVideoGrid />
        <div className="flex items-center justify-center pb-8">
          <CustomMeetingControls mode="video" />
        </div>
      </div>
    </AppTemplate>
  )
}
